import React from 'react';
import { useLinesContext } from '../../../../contexts/Lines';
import {
  lazyLoadOffset,
  stage as stageEnum,
  getVisibleStartDate,
  getVisibleEndDate,
  getAddStageButtonWidth,
} from '../../../../utils';
import cloneDeep from 'lodash.clonedeep';
import makeStyles from '@material-ui/core/styles/makeStyles';
import LineProgress from './LineProgress';
import StockOnHand from '../Desktop/StockOnHand';
import LazyLoad from 'react-lazyload';
import LineDurationPlaceHolder from '../../Placeholders/LineDurationPlaceHolder';
import CompleteOrRepay from './CompleteOrRepay';

const useStyles = makeStyles((theme: any) => ({
  lineDuration: {
    position: 'absolute',
    marginTop: theme.spacing(0.75),
    width: '100%',
  },
  durationContainer: {
    height: theme.spacing(2.5),
    backgroundColor: '#fff',
  },
  lazyContainer: {
    position: 'absolute',
    display: 'block',
    top: 22,
    left: 1,
    zIndex: theme.zIndex.pageContent + 1,
  },
  stockOnHandPositioning: {
    top: theme.spacing(0.5),
  },
}));

export default function LineDuration({
  line,
  onboarding = false,
  handleStageUpdate,
  addOrDeleteError,
  setAutoSave = (arg) => {},
  openStockOnHand,
  setOpenStockOnHand,
}) {
  const classes = useStyles();
  const { timelineInfo } = useLinesContext();

  const lineUpdated = cloneDeep(line);
  lineUpdated['visibleStartDate'] = getVisibleStartDate(
    lineUpdated,
    timelineInfo,
  );
  lineUpdated['visibleEndDate'] = getVisibleEndDate(lineUpdated, timelineInfo);

  const conatinerWidth =
    onboarding || line.edit || line.editActiveLine
      ? `calc(100% - ${getAddStageButtonWidth(line, onboarding) + 2}px)`
      : `calc(100% - 2px)`;

  return (
    <LazyLoad
      className={classes.lazyContainer}
      offset={lazyLoadOffset}
      placeholder={<LineDurationPlaceHolder />}
      style={{
        width: conatinerWidth,
      }}
    >
      <div className={classes.durationContainer}>
        <div className={classes.lineDuration}>
          <LineProgress line={lineUpdated} onboarding={onboarding} />
        </div>
        <StockOnHand
          line={lineUpdated}
          handleStageUpdate={handleStageUpdate}
          addOrDeleteError={addOrDeleteError}
          timelineInfo={timelineInfo}
          setAutoSave={setAutoSave}
          open={openStockOnHand}
          setOpen={setOpenStockOnHand}
          className={classes.stockOnHandPositioning}
        />
        <CompleteOrRepay
          line={lineUpdated}
          stageName={stageEnum.repaymentsStart.value}
          timelineInfo={timelineInfo}
        />
        <CompleteOrRepay
          line={lineUpdated}
          stageName={stageEnum.complete.value}
          timelineInfo={timelineInfo}
        />
      </div>
    </LazyLoad>
  );
}
